<section class="table-panel">
  <header class="table-panel-header">
    <div>
      <p class="eyebrow">Pages</p>
      <h2>Landing pages</h2>
    </div>
    <div class="header-actions">
      <button type="button" class="ghost" [disabled]="busy" (click)="importRequested.emit()">
        Import from Markdown
      </button>
      <button type="button" class="accent" [disabled]="busy" (click)="createRequested.emit()">
        New landing page
      </button>
    </div>
  </header>

  @if (activeFilters.length) {
    <section class="active-filters-band" aria-label="Applied landing page filters">
      <div class="active-filters-copy">
        <p class="active-filters-label">Filters</p>
        <div class="active-filters-list">
          @for (tag of activeFilters; track tag) {
            <button
              type="button"
              class="content-tag tag-filter-chip is-active"
              [disabled]="busy"
              [attr.aria-pressed]="true"
              (click)="filterToggled.emit(tag)">
              {{ tag }}
            </button>
          }
        </div>
      </div>
      <button type="button" class="ghost small clear-filters-button" [disabled]="busy" (click)="clearFiltersRequested.emit()">
        Clear all
      </button>
    </section>
  }

  @if (busy) {
    <p class="empty-state">Loading landing pages...</p>
  } @else if (landingPages.length) {
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th scope="col">Title</th>
            <th scope="col">Path</th>
            <th scope="col">Tags</th>
            <th scope="col">Status</th>
            <th scope="col">Updated</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (landingPage of landingPages; track landingPage.id) {
            <tr>
              <td class="title-cell">
                <div class="landing-page-primary">
                  <strong>{{ landingPage.title }}</strong>
                </div>
              </td>
              <td><code>{{ landingPage.path }}</code></td>
              <td>
                @if (landingPage.tags.length) {
                  <div class="content-tags">
                    @for (tag of landingPage.tags; track tag) {
                      <button
                        type="button"
                        class="content-tag tag-filter-chip"
                        [class.is-active]="isFilterActive(tag)"
                        [disabled]="busy"
                        [attr.aria-pressed]="isFilterActive(tag)"
                        (click)="filterToggled.emit(tag)">
                        {{ tag }}
                      </button>
                    }
                  </div>
                } @else {
                  <span class="empty-tags">None</span>
                }
              </td>
              <td>
                <span class="status-chip" [attr.data-state]="landingPage.publicationState.toLowerCase()">
                  {{ landingPage.publicationState }}
                </span>
              </td>
              <td>{{ landingPage.updatedAt | date: 'short' }}</td>
              <td class="actions-cell">
                <button type="button" class="ghost small" (click)="landingPageOpened.emit(landingPage.id)">Open</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <p class="empty-state">No landing pages yet for this site. Create the first draft to open the editor.</p>
  }
</section>
